import { MOBILE_TABS, filterByRoles, isItemActive } from "@/lib/nav-config";
import { cn } from "@/lib/utils";
import { useAuthStore } from "@/stores/auth";
import { useRouteStore } from "@/stores/route";

/**
 * Bottom tabs nav cho mobile (< 768px).
 *
 * Up to 5 items. Items không passing required role sẽ ẩn — tab bar tự
 * shrink. Doc 28 §4.
 */
export function MobileNav(): JSX.Element {
  const navigate = useRouteStore((s) => s.navigate);
  const currentRoute = useRouteStore((s) => s.current);
  const user = useAuthStore((s) => s.user);
  const roles = user?.roles ?? [];

  const tabs = filterByRoles(MOBILE_TABS, roles);

  return (
    <nav
      data-testid="mobile-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 h-14 border-t bg-background/90 backdrop-blur-xl flex items-stretch shadow-card-lg"
      aria-label="Mobile primary"
    >
      {tabs.map((item) => {
        const Icon = item.icon;
        const active = isItemActive(item, currentRoute);
        return (
          <button
            key={item.route + item.label}
            type="button"
            onClick={() => navigate(item.route, item.param)}
            className={cn(
              "relative flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors",
              active ? "text-primary" : "text-muted-foreground hover:text-foreground",
            )}
            aria-current={active ? "page" : undefined}
          >
            <Icon className="size-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
            {active ? (
              <span
                aria-hidden
                className="absolute top-0 inset-x-4 h-0.5 bg-gradient-brand rounded-b-full"
              />
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
